import { createContext } from 'react';

const HeaderContext = createContext();

export const { Provider, Consumer } = HeaderContext;

export default HeaderContext;
